import React, { useEffect, useState } from "react";
import {
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
} from "@mui/material";
import CustomCheckbox from "./CustomCheckbox";
import ManualRow from "./ManualRow";
import ManualSkeleton from "./ManualSkeleton";
import NoData from "../../components/NoData/NoData";

const cellStyle = {
  padding: "10px 16px",
};

const ManualTable = ({ isMembersView = false, isInviteView = false, data = [] }) => {
  const [selectedRows, setSelectedRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1500);
    return () => clearTimeout(timer);
  }, []);

  const handleSelectAll = () => {
    if (selectedRows.length === data.length) {
      setSelectedRows([]);
    } else {
      setSelectedRows(data.map((row) => row.id));
    }
  };

  const handleRowToggle = (id) => () => {
    setSelectedRows((prev) =>
      prev.includes(id) ? prev.filter((rowId) => rowId !== id) : [...prev, id]
    );
  };

  const allSelected = selectedRows.length === data.length && data.length > 0;
  const someSelected = selectedRows.length > 0 && !allSelected;

  return (
    <>

      <TableContainer
        component={Paper}
        sx={{ boxShadow: "none", background: "transparent", marginBottom: "24px" }}
      >
        <Table size="small" sx={{ borderCollapse: "separate", borderSpacing: "0 5px" }}>
          <TableHead sx={{ backgroundColor: "#DFDFDF" }}>
            <TableRow>
              <TableCell
                sx={{
                  ...cellStyle,
                  border: "none",
                  minWidth: "50px",
                  maxWidth: "32px",
                  borderTopLeftRadius: "10px",
                  borderBottomLeftRadius: "10px",
                }}
              >
                <CustomCheckbox
                  checked={allSelected}
                  indeterminate={someSelected}
                  onChange={handleSelectAll}
                />
              </TableCell>
              <TableCell sx={{ ...cellStyle, border: "none", color: "#626262", textAlign: "center" }}>
                #
              </TableCell>
              {!isMembersView && (
                <TableCell sx={{ ...cellStyle, border: "none", color: "#626262", textAlign: "center" }}>
                  Date Invite
                </TableCell>
              )}
              <TableCell sx={{ ...cellStyle, border: "none", color: "#626262", textAlign: "left" }}>
                Member
              </TableCell>
              <TableCell sx={{ ...cellStyle, border: "none", color: "#626262", textAlign: "center" }}>
                Status
              </TableCell>
              <TableCell
                sx={{ ...cellStyle, border: "none", color: "#626262", textAlign: "center", whiteSpace: "nowrap" }}
              >
                Role
              </TableCell>
              <TableCell
                sx={{ ...cellStyle, border: "none", color: "#626262", textAlign: "center", whiteSpace: "nowrap" }}
              >
                Projects
              </TableCell>
              <TableCell
                sx={{ ...cellStyle, border: "none", color: "#626262", textAlign: "center", whiteSpace: "nowrap" }}
              >
                Payment
              </TableCell>
              <TableCell
                sx={{ ...cellStyle, border: "none", color: "#626262", textAlign: "center", whiteSpace: "nowrap" }}
              >
                Limits
              </TableCell>
              {!isInviteView && (
                <TableCell
                  sx={{ ...cellStyle, border: "none", color: "#626262", textAlign: "center", whiteSpace: "nowrap" }}
                >
                  Time tracking status
                </TableCell>
              )}
              {!isInviteView && (
                <TableCell
                  sx={{
                    ...cellStyle,
                    border: "none",
                    borderTopRightRadius: "10px",
                    borderBottomRightRadius: "10px",
                    textAlign: "center",
                    whiteSpace: "nowrap",
                  }}
                >
                  Date added
                </TableCell>
              )}
              {!isMembersView && (
                <TableCell
                  sx={{
                    ...cellStyle,
                    border: "none",
                    borderTopRightRadius: "10px",
                    borderBottomRightRadius: "10px",
                    textAlign: "center",
                    whiteSpace: "nowrap",
                  }}
                >
                  Action
                </TableCell>
              )}
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              [...Array(3)].map((_, i) => <ManualSkeleton key={i} isMembersView={isMembersView} isInviteView={isInviteView} />)
            ) : data.length === 0 ? (
              <TableRow>
                <TableCell colSpan={9} align="center" sx={{ padding: "40px 16px" }}>
                  <NoData />
                </TableCell>
              </TableRow>
            ) : (
              data.map((row) => (
                <ManualRow
                  key={row.id}
                  row={row}
                  isSelected={selectedRows.includes(row.id)}
                  onSelectToggle={handleRowToggle(row.id)}
                  isMembersView={isMembersView}
                  isInviteView={isInviteView}
                />
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default ManualTable;
